var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransfer2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.46967 17.5304C3.32902 17.3897 3.25 17.1989 3.25 17C3.25 16.8011 3.32902 16.6103 3.46967 16.4697L8.46967 11.4697C8.68417 11.2552 9.00676 11.191 9.28701 11.3071C9.56727 11.4232 9.75 11.6967 9.75 12V16.25H20C20.4142 16.25 20.75 16.5858 20.75 17C20.75 17.4142 20.4142 17.75 20 17.75H9.75V22C9.75 22.3034 9.56727 22.5768 9.28701 22.6929C9.00676 22.809 8.68417 22.7449 8.46967 22.5304L3.46967 17.5304Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5303 7.53035C20.671 7.3897 20.75 7.19893 20.75 7.00002C20.75 6.80111 20.671 6.61034 20.5303 6.46969L15.5303 1.46969C15.3158 1.25519 14.9932 1.19103 14.713 1.30711C14.4327 1.4232 14.25 1.69668 14.25 2.00002V6.25002H4C3.58579 6.25002 3.25 6.58581 3.25 7.00002C3.25 7.41424 3.58579 7.75002 4 7.75002H14.25V12C14.25 12.3034 14.4327 12.5768 14.713 12.6929C14.9932 12.809 15.3158 12.7449 15.5303 12.5304L20.5303 7.53035Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer2);
export default __webpack_public_path__ + "static/media/transfer-2.7f95b7832f50d0ae2156c448b202c224.svg";
export { ForwardRef as ReactComponent };